import { Box, useMedia } from '@stitch-fix/mode-react';
import { A } from '@mobily/ts-belt';
import classNames from 'classnames';
import { AnimatePresence, motion, MotionConfig } from 'framer-motion';
import styles from './styles.module.scss';
const AnimatingIndicator = ({
  animate,
  durationMs,
  isInView,
  nextSlide,
  shouldAutoAdvance
}: {
  animate: boolean;
  durationMs: number;
  isInView: boolean;
  nextSlide: () => void;
  shouldAutoAdvance: boolean;
}) => {
  if (!animate) return null;
  return <MotionConfig reducedMotion="user">
      <AnimatePresence>
        <motion.div className={styles.filled} style={{
        height: '100%'
      }} initial={{
        width: 0
      }} animate={isInView ? {
        width: '100%'
      } : {}} transition={{
        duration: durationMs / 1000
      }} onAnimationComplete={isInView && shouldAutoAdvance ? nextSlide : undefined} data-testid="animating-indicator" />
      </AnimatePresence>
    </MotionConfig>;
};
interface ProgressIndicatorProps {
  currentSlide: number;
  slideCount: number;
  nextSlide: () => void;
  durationMs?: number;
  isInView: boolean;
}
export const ProgressIndicator = ({
  durationMs = 3000,
  currentSlide,
  isInView,
  nextSlide,
  slideCount
}: ProgressIndicatorProps) => {
  const prefersReducedMotion = useMedia('(prefers-reduced-motion: reduce)');
  const pagingDotsIndices = A.range(0, slideCount - 1) as number[];
  return <Box className={styles.indicatorsContainer} as="ul">
      {pagingDotsIndices.map(index => <Box as="li" style={{
      width: `${100 / slideCount}%`
    }} className={classNames(styles.indicator, {
      [styles.filled]: index < currentSlide
    })} key={`indicator-${index}`} data-testid="indicator">
          <AnimatingIndicator animate={index === currentSlide} durationMs={durationMs} isInView={isInView} nextSlide={nextSlide} shouldAutoAdvance={!prefersReducedMotion} />
        </Box>)}
    </Box>;
};